import { AbilityCan, AbilitySubjects, UserRole } from '../../enums';
import { IAbilityFunction } from '../abilities.types';
import { ICaslCondition } from '../utils';
import { IToxicLimitCalculatedSubject } from './toxicLimitTypes';

const { CRUD, READ } = AbilityCan;
const { ADMIN, EMPLOYEE, EXTERNAL_RECEIVER } = UserRole;

// forbid argument kept for uniform define ability calls
export function defineAbilitiesForToxicLimits(_allow: IAbilityFunction, _forbid: IAbilityFunction) {
    type SubjectShape = ICaslCondition<IToxicLimitCalculatedSubject>;

    const allow = (can: AbilityCan | AbilityCan[], shape: SubjectShape) =>
        _allow(can, AbilitySubjects.TOXIC_LIMITS, shape);

    allow(CRUD, { relationRole: ADMIN });
    allow(READ, { relationRole: EMPLOYEE });
    allow(READ, { relationRole: EXTERNAL_RECEIVER });
}
